import { OnSiteLocationType, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Historia zamówień',
  labels: {
    dummy_order: 'Zamówienie testowe',
    orders_number: 'Liczba zamówień ({{count}})',
    revenue: 'Przychód: {{amount}}',
    tips: 'Napiwki: {{amount}}',
    cash_sales: ' ({{amount}} gotówka)',
    refunds: 'Zwroty: {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Odbiór osobisty',
    [OrderMethod.Delivery]: 'Dostawa',
    [OrderMethod.OnSite]: {
      [OnSiteLocationType.RoomService]: 'Obsługa pokoju',
      [OnSiteLocationType.TableService]: 'Obsługa stolika',
    },
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'W trakcie',
    [OrderFulfillmentStatus.Reviewed]: 'W trakcie',
    [OrderFulfillmentStatus.Accepted]: 'W trakcie',
    [OrderFulfillmentStatus.Preparing]: 'W trakcie',
    [OrderFulfillmentStatus.Ready]: 'W trakcie',
    [OrderFulfillmentStatus.OnDelivery]: 'W trakcie',
    [OrderFulfillmentStatus.Picked]: 'Zakończone',
    [OrderFulfillmentStatus.Rejected]: 'Odrzucone',
  },
  payment_methods: {
    invoice: 'Faktura',
    cash: 'Gotówka',
    online: 'Metoda online',
  },
  filters: {
    all: 'Wszystkie',
  },
  fields: {
    order_placed: 'Zamówienie złożone',
    order_number: '#',
    customer: 'Klient',
    payment_method: 'Metoda płatności',
    method: 'Typ',
    status: 'Status',
    total: 'Łącznie',
  },
  buttons: {
    print: 'Drukuj',
    create_test_order: 'Utwórz zamówienie testowe',
  },
  toasts: {
    failed_to_fetch_orders: 'Nie udało się załadować danych. Kliknij ikonę „odśwież" lub spróbuj ponownie za 1 minutę.',
    something_went_wrong: 'Coś poszło nie tak, spróbuj ponownie.',
    failed_to_create_test_order: 'Nie udało się utworzyć zamówienia testowego',
    test_order_created: 'Zamówienie testowe utworzone',
  },
};
